import {load} from '@shopify/theme-sections';

import '../sections/collection-header';
import '../sections/collection-main';

import initScrollTopButton from '../components/scroll-top-button.js';

const template = 'collection';

export default (function () {
  if (document.body.dataset.template !== template) return;

  load('*');

  initScrollTopButton();
})();
